﻿import { IPotentialDonor } from './potential-donor';
import { IRecipient } from './recipient';
import { IWaitlistAllocationPoints } from './waitlist-allocation-points';

export interface ICompatibilityResult {
    hlaPointsA: number;
    hlaPointsB: number;
    hlaPointsDr: number;
    totalHlaPoints: number;
    isAboCompatible: boolean;
    isHardBlocked: boolean;
    donor: IPotentialDonor;
    recipient: IRecipient;
    epletMMRisk: string;
    failedAvoids: string[];
    waitlistAllocationPoints: IWaitlistAllocationPoints;
}
